import { ALL_GUESTS, CARD_NAMES, getPlayerDocksData } from '../../TwoD/Common/CardUtilities';

export default function artificialScorePhase(gamePlayerController, aiPackage) {
    let dockedGuests = gamePlayerController.gamePlayerData.docks.filter(cardId => ALL_GUESTS.includes(cardId));
    let question = 'How many Guests do I have?';
    let answer = dockedGuests.length;
    let reasoning = 'I need Guests to Score.'
    aiPackage.addProvenance(question, answer, reasoning);
    if (dockedGuests.length === 0) {
        aiPackage.success = true;
        aiPackage.addToMessage(`Waiting for others to Score.`);
        return aiPackage;
    }

    let docksData = getPlayerDocksData(gamePlayerController.gamePlayerData);
    let filteredData = docksData.filter(dockData =>(dockData.id !== null && !dockData.isGhost));
    filteredData.sort((a, b) => a.pointData.points - b.pointData.points);
    const points = filteredData[0].pointData.points;
    const dockId = filteredData[0].dock;
    aiPackage.success = true;

    const cardId = gamePlayerController.gamePlayerData.docks[dockId];
    const name = CARD_NAMES[cardId];

    question = 'Which Dock earns the most?'
    answer = `${name} in Dock ${dockId}`
    reasoning = 'Pick the high earners first.'
    aiPackage.addProvenance(question, answer, reasoning);

    const message = `Choose ${name} in Dock ${dockId} for ${points} Snohe`;
    aiPackage.addToMessage(message);

    // aiPackage.addProvenance();
    if (aiPackage.execute) {
        console.log('Execute', message);
        gamePlayerController.gamePlayerApi.clickScoreDock(dockId);
    }
}
